import { Home as HomePage } from './home'
import { withBottomPanel } from '../../components/bottom-panel/with-bottom-panel'

export const HomeStack = {
  HomePage: withBottomPanel(HomePage),
}
